import Util from './util.js'

let RelatedReading = Vue.component('related-reading', {
	props: ['related'],
	methods: {
		clickLink: function(e) {
			this.$root.clickLink(e)
		}
	},
	template: `
	<div v-if="related" class="section-related">
		<transition-group name="fade" tag="ul" class="post-list">
			<li v-for="(post, index) in posts" :key="post.ID">
				<colored-link :type="post.post_type" :data-id="post.ID" :href="post.permalink" v-html="post.post_title"></colored-link>
			</li>
		</transition-group>
	</div>`
})

export default RelatedReading
